<template>
  <button
    :type="type"
    class="base-button jm-py-2"
    data-test="base-button"
    :disabled="disabledButton"
  >
    <spinner-loader
      data-test="spinner"
      v-if="loading"
      class="jm-mr-2"
    ></spinner-loader>
    <slot v-else></slot>
  </button>
</template>

<script>
import SpinnerLoader from '@/components/atoms/SpinnerLoader.vue'

export default {
  name: 'BaseButton',
  components: { SpinnerLoader },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  computed: {
    disabledButton() {
      return this.loading || this.disabled
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button {
  // reset default styles button
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
  &:focus {
    outline: none;
  }

  // custom style
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: $min-width-button;
  font-family: $font-bold;
  color: $black;
  text-transform: uppercase;
  letter-spacing: 0.06rem;
  border-radius: $border-radius-sm;
  border: $border-width-sm solid $black;
  padding: $spacing-2 $spacing-5;
  margin: 0 auto;

  &:active,
  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    color: $white;
    background-color: $grey-300;
    border: 0;
    opacity: 0.9;
  }

  &:hover {
    &:not(:disabled) {
      @media (hover: hover) {
        color: $white;
        background-color: $black;
      }
    }
  }
}
</style>
